import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { HttpClientModule } from '@angular/common/http';
import { RouterModule } from '@angular/router';
import { SchedaProdottoComponent } from './scheda-prodotto.component';
import { ProdottiComponent } from '../layout/components/prodotti/prodotti.component';
import { NgbModule } from '@ng-bootstrap/ng-bootstrap';
import { FormsModule } from '@angular/forms';
import { ProdottiModule } from '../layout/components/prodotti/prodotti.module';



@NgModule({
  declarations: [SchedaProdottoComponent],
  imports: [
    CommonModule,
    HttpClientModule,
    NgbModule,
    FormsModule,
    //ProdottiModule,
    /* RouterModule.forChild([
      {
        path: '',
        component: SchedaProdottoComponent,
        
      }
    ]), */
  ],
  exports: [
    SchedaProdottoComponent
  ]
})
export class SchedaProdottoModule { }
